import React from "react";

const DonationWays = () => {
  return (
    <div className="bg-white pt-20">
      {/* Header */}
      <header className="bg-blue-800 text-white py-16 text-center">
        <h1 className="text-4xl font-extrabold mb-4">
          Donate to Indangalasia Lightstar Academy
        </h1>
        <p className="max-w-2xl mx-auto text-lg">
          Your support provides education, meals, and hope to children in need.
        </p>
      </header>

      {/* Donation Options */}
      <section id="donate-options" className="py-16 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-12 text-gray-800">
            Choose How You Want to Give
          </h2>

          <div className="grid md:grid-cols-3 gap-10">
            {/* One-Time Donation */}
            <div
              id="one-time"
              className="p-6 bg-gray-50 border rounded-lg shadow-md text-center hover:shadow-lg transition"
            >
              <h3 className="text-2xl font-bold text-blue-800 mb-4">💳 One-Time Donation</h3>
              <p className="text-gray-700 mb-6">
                Support Lightstar Academy with a single, powerful gift.
              </p>
              <form className="flex flex-col items-center space-y-4">
                <input
                  type="number"
                  placeholder="Enter amount (e.g. €20)"
                  className="px-4 py-2 border rounded-md w-3/4 focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-5 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
                >
                  Donate Once
                </button>
              </form>
            </div>

            {/* Monthly Donation */}
            <div
              id="monthly"
              className="p-6 bg-gray-50 border rounded-lg shadow-md text-center hover:shadow-lg transition"
            >
              <h3 className="text-2xl font-bold text-green-700 mb-4">🔁 Monthly Support</h3>
              <p className="text-gray-700 mb-6">
                Commit to helping children every month.
              </p>
              <form className="flex flex-col items-center space-y-4">
                <input
                  type="number"
                  placeholder="Monthly amount (e.g. €20)"
                  className="px-4 py-2 border rounded-md w-3/4 focus:outline-none focus:ring-2 focus:ring-green-400"
                />
                <button
                  type="submit"
                  className="bg-green-600 text-white px-5 py-3 rounded-lg font-semibold hover:bg-green-700 transition"
                >
                  Start Monthly Giving
                </button>
              </form>
            </div>

            {/* Custom Donation */}
            <div
              id="custom"
              className="p-6 bg-gray-50 border rounded-lg shadow-md text-center hover:shadow-lg transition"
            >
              <h3 className="text-2xl font-bold text-yellow-600 mb-4">💛 Custom Giving</h3>
              <p className="text-gray-700 mb-6">
                Choose an amount and support what matters most to you.
              </p>
              <form className="flex flex-col items-center space-y-4">
                <input
                  type="number"
                  placeholder="Custom amount"
                  className="px-4 py-2 border rounded-md w-3/4 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
                <select className="px-4 py-2 border rounded-md w-3/4 focus:outline-none focus:ring-2 focus:ring-yellow-400">
                  <option value="">Select Area of Impact</option>
                  <option value="meals">School Meals</option>
                  <option value="tuition">Tuition Fees</option>
                  <option value="supplies">Supplies & Uniforms</option>
                </select>
                <button
                  type="submit"
                  className="bg-yellow-500 text-white px-5 py-3 rounded-lg font-semibold hover:bg-yellow-600 transition"
                >
                  Give Now
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DonationWays;
